import { StoreId } from '@/store'
import { DIALOGS_STORE_STATE } from '@/store/dialogs/dialogs.constants'
import type {
  DialogName,
  DialogProps,
  DialogsStoreState,
} from '@/store/dialogs/dialogs.types'

export const useDialogsStore = defineStore(StoreId.DIALOGS, {
  state: (): DialogsStoreState => DIALOGS_STORE_STATE,
  actions: {
    showDialog(name: DialogName, props?: DialogProps) {
      if (!this.dialogs[name]) return

      this.dialogs[name].visible = true
      this.dialogs[name].props = props
    },
    closeDialog(name: DialogName) {
      this.dialogs[name].visible = false
    },
  },
})
